import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import config from 'config/config';
import { setGlobalError } from 'containers/ErrorHandler/actions';
import globalMessages from 'translations/messages/global-messages';
import checkOrSetSlash from 'utils/checkOrSetSlash';
import { prepareFCHeader } from 'utils/request';

const rootProjectPath = `${checkOrSetSlash(config.apiHostGateway, 'apiHostGateway')}api/v1.1/`;

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: fetchBaseQuery({
    baseUrl: rootProjectPath,
    prepareHeaders: prepareFCHeader(),
  }),
  endpoints: builder => ({
    verifyEmail: builder.mutation({
      query: ({ email }) => ({
        url: `user/verify-email/${email}`,
        method: 'POST',
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (!data?.is_email_verified) {
            dispatch(
              setGlobalError({
                data,
                customErrorMessageIntl: globalMessages.inexisting_email,
              }),
            );
          }
        } catch (error) {
          console.error('Error verifiying email:', error);
        }
      },
    }),
  }),
});

export const { useVerifyEmailMutation } = userApi;
